import type { PartnerFilterDto, PartnerSkills } from "Infrastructure/Api/Api";
import { useMarket } from "Market/Providers/CurrentMarketProvider";
import { selectedVerticalsAtom } from "Shared/Atoms/verticalAtom";
import { DEFAULT_VERTICALS } from "Shared/consts";
import { useAtom } from "jotai";
import { useMemo } from "react";
import { useSearchParams } from "react-router";

export const usePartnerFilters = (): PartnerFilterDto => {
	const { market } = useMarket();
	const [query] = useSearchParams();
	const [selectedVerticals] = useAtom(selectedVerticalsAtom);

	return useMemo(
		() => ({
			// "0" means All markets (no country filter); absent defaults to the current market
			marketId:
				query.get("marketId") === "0"
					? undefined
					: query.get("marketId")
						? Number(query.get("marketId"))
						: (market?.id ?? undefined),
			query: query.get("query") ?? undefined,
			skills: (query.getAll("skills") as PartnerSkills[]) ?? undefined,
			verticals:
				selectedVerticals.length > 0
					? selectedVerticals.join(",")
					: DEFAULT_VERTICALS,
		}),
		[query, market?.id, selectedVerticals],
	);
};
